import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import BlobImage from 'components/blobImage';
import { setShowSuccess } from 'actions/ui';
import { Copy, DeleteWarning, Forms, SaveButton, SystemText } from 'e4shared';
import { e4Format } from 'helpers/dates';

export const TaskShareCommentSection = ({
    task,
    shareComments,
    profile,
    user,
    permissions,
    saveSharedComments,
    deleteSharedComment,
}) => {
    const dispatch = useDispatch();
    const { tags, handles } = useSelector(state => state.ui);

    const [saving, setSaving] = React.useState(false);
    const [comments, setComments] = React.useState('');
    const [error, setError] = React.useState('');
    const [showWarning, setShowWarning] = React.useState(false);
    const [deleteId, setDeleteId] = React.useState(null);

    const saveComments = () => {
        if (comments) {
            const comment = {
                profile_Task_Id: task.id,
                task_Id: task.task_Id,
                profile_Id: profile.id,
                owner_Id: user.id,
                comment: comments,
                submitted: true,
            };

            saveSharedComments(comment, () => {
                setComments('');
                dispatch(setShowSuccess(SystemText('Objective/Comment/Success')));
            });
        } else {
            setError(SystemText('Objective/Comment/Error'));
        }

        setSaving(false);
    };

    return (
        <div>
            <div className="form-group" id="comment-section">
                <Forms.Textarea
                    data-testid="text-comments"
                    tags={tags}
                    handles={handles}
                    rows="3"
                    value={comments}
                    onChange={c => {
                        c && setError('');
                        setComments(c);
                    }}
                    placeholder={SystemText('Objective/Comment/Placeholder')}
                    error={error}
                />
                <div className="text-right mtm10">
                    <SaveButton
                        data-testid="button-save"
                        saving={saving}
                        setSaving={setSaving}
                        className="btn btn-success btn-blockx btn-sm"
                        onClick={() => saveComments()}
                    >
                        <i className={`fa fa-commenting mr10`} />
                        {SystemText('Objective/Comment/Button')}
                    </SaveButton>
                </div>
            </div>
            <hr className="mrm10 mlm10 mtm5 mb10" />
            {shareComments?.length ? (
                <div>
                    {shareComments
                        .sort((a, b) => (a.date_Added < b.date_Added ? 1 : -1))
                        .map(comment => (
                            <div key={comment.id} className="user-comment">
                                <div>
                                    <Link to={`/search/${comment.owner_Full_Name}`}>
                                        <BlobImage
                                            folder="avatar"
                                            initials={comment.owner_Initials}
                                            alt={comment.owner_Full_Name}
                                            src={comment.owner_Avatar}
                                            key={comment.owner_Avatar}
                                        />
                                    </Link>
                                </div>
                                <div>
                                    <div>
                                        <Link to={`/search/${comment.owner_Full_Name}`}>{comment.owner_Full_Name}</Link>
                                        {permissions.objectives.canDeleteComment(comment.owner_Id) && (
                                            <i
                                                data-testid="i-delete"
                                                onClick={() => {
                                                    setDeleteId(comment.id);
                                                    setShowWarning(true);
                                                }}
                                                className="ml10 pointer fa fa-trash text-danger"
                                                title={SystemText('Objective/Comment/Delete')}
                                            />
                                        )}
                                    </div>
                                    <div className="date">{e4Format(comment.date_Added, null, true)}</div>
                                    <div className="mb10 comment">
                                        <Copy value={comment.comment} />
                                    </div>
                                </div>
                            </div>
                        ))}
                </div>
            ) : (
                <div className="p10">{SystemText('Objective/Comment/None')}</div>
            )}
            <DeleteWarning
                id="commentWarning"
                message={SystemText('Objective/Comment/Warning')}
                show={showWarning}
                close={confirm => {
                    setShowWarning(false);
                    confirm && deleteSharedComment && deleteSharedComment(deleteId);
                }}
            />
        </div>
    );
};

export default TaskShareCommentSection;
